/* Lazy Loading of images */
jQuery(function($) {
    'use strict';

    $.fn.lazyLoadImage = lazyLoadImage;
    $('.lazy-load-image').lazyLoadImage();

    ////////////////////

    function lazyLoadImage() {
        // scrollin comes from sonar library
        $(this).on('scrollin.lazy-load-image', function() { // jshint ignore:line
            var $anchor = $(this);
            var imgSrc = $anchor.data('img-src');
            var $image = $('<img style="display: none;" src="' + imgSrc + '" alt="' + $anchor.text() + '">');

            $anchor.off(".lazy-load-image");

            $image.on('load', function(){
                $image.hide().fadeIn(150);
                $image.off('load');
            });

            $anchor.empty().append($image);
            $anchor.attr('img-loaded', 'true');
        });
    }
});

